import script from "./exam-sheet.vue?vue&type=script&lang=ts&setup=true"
export * from "./exam-sheet.vue?vue&type=script&lang=ts&setup=true"

import "./exam-sheet.vue?vue&type=style&index=0&id=56407795&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56407795"]])

export default __exports__